import { render, staticRenderFns } from "./ShopStatisticCard.vue?vue&type=template&id=29002a3e&scoped=true"
import script from "./ShopStatisticCard.vue?vue&type=script&lang=js"
export * from "./ShopStatisticCard.vue?vue&type=script&lang=js"
import style0 from "./ShopStatisticCard.vue?vue&type=style&index=0&id=29002a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29002a3e",
  null
  
)

export default component.exports